import React from 'react';
import Radio from './Radio';

interface RadiosOption {
  id: string;
  value: string;
  disabled?: boolean;
}

interface RadiosProps {
  name?: string;
  options?: RadiosOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  legend?: string;
  hint?: string;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  className?: string;
}

const DEFAULT_OPTIONS: RadiosOption[] = [{ id: 'option1', value: 'Option 1' }];

const Radios: React.FC<RadiosProps> = ({
  name = 'options',
  options = DEFAULT_OPTIONS,
  selectedValue,
  onChange,
  legend,
  hint,
  hintClassName,
  hintId,
  hintHidden,
}) => {
  return (
    <>
      {legend ? <legend>{legend}</legend> : null}
      {options.map((option) => (
        <Radio
          key={option.id}
          id={option.id}
          name={name}
          value={option.value}
          checked={option.value === selectedValue}
          onChange={() => onChange(option.value)}
          disabled={option.disabled}
        />
      ))}
      {hint ? (
        <small
          id={hintId}
          hidden={hintHidden}
          className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
        >
          {hint}
        </small>
      ) : null}
    </>
  );
};

export default Radios;
